export enum Variant {
	BRAND = 'brand',
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	TRANSPARENT = 'transparent',
}
